import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";

import { contactFormReducer } from "./reducers/contactFormReducers";
import { userReducer } from "./reducers/userReducer";

const reducer = combineReducers({
  contactForm: contactFormReducer,
  user: userReducer,
});

const middleware = [thunk];

const store = createStore(
  reducer,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
